const setStocks = (state, stocks) => (state.stocks = stocks);

const setStockWithoutPagination = (state, StockWithoutPagination) =>
  (state.StockWithoutPagination = StockWithoutPagination);

let mutations = {
  setStockWithoutPagination,
  setStocks
};

export default mutations;
